import styled from "styled-components";
import { Device } from "@pepdirect/v3/styles/screenSizes";
import { AUTH_PAGE_CONTENT_WIDTH } from "@pepdirect/v3/styles/variables";

export const StyledAccountContent = styled.div`
  max-width: ${AUTH_PAGE_CONTENT_WIDTH};
  margin: 90px auto 0;

  @media ${Device.mobile} {
    margin-top: 60px;
    padding: 0 20px;
  }
`;

export const StyledLinkWrapper = styled.div`
  > :hover {
    cursor: pointer;
  }
  margin-bottom: 25px;
`;

export const StyledImage = styled.img`
  height: 40px;
  width: auto;
  object-fit: contain;
`;

export const StyledMain = styled.main`
  margin-top: 60px;
`;
